export const HIGHLIGHT_CONSTS = {
    GET_HIGHLIGHTS: "GET_HIGHLIGHTS",
    DELETE_HIGHLIGHT: "DELETE_HIGHLIGHT",
    CLEAR_HIGHLIGHT: "CLEAR_HIGHLIGHT",
};
